<template>

  <div
    id="main-pos"
    :style="'height:'+ pageHeight + 'px'">

    <vue-progress-bar/>

    <div class="content">

      <chooseproduct-view
        v-if="pos.section == 'choose-product'"
        :ready.sync="isChooseProductReady"
        :loaded="ready"
        class="choose-product"
      />

      <chooseattribute-view
        v-if="pos.section == 'choose-attribute'"
        class="choose-attribute"/>

      <customprice-view
        v-if="pos.section == 'custom-price'"
        class="custom-price"/>

      <queuelist-view
        v-if="pos.section == 'queues'"
        class="queues"/>

      <tablelist-view
        v-if="pos.section == 'tables'"
        class="tables"/>

      <dininglist-view
        v-if="pos.section == 'dining-options'"
        class="dining-options"/>

      <customerlist-view
        v-if="pos.section == 'customers'"
        class="customers"/>

      <payment-view
        v-if="pos.section == 'payment'"
        class="payment"/>

      <paymentcomplate-view
        v-if="pos.section == 'payment-complate'"
        class="payment-complate"/>

    </div>

    <audio
      ref="audioPlayer"
      style="display: none;">
      <source
        src="@/assets/audios/mixkit-arcade-bonus-alert-767.wav"
        type="audio/wav">
      Your browser does not support the audio element.
    </audio>

  </div>

</template>

<script>
import chooseproductView from '@/components/apps/pos/sale/main/include/ChooseProduct.vue'
import chooseattributeView from '@/components/apps/pos/sale/main/include/ChooseAttribute.vue'
import custompriceView from '@/components/apps/pos/sale/main/include/CustomPrice.vue'
import queuelistView from '@/components/apps/pos/sale/main/include/QueueList.vue'
import dininglistView from '@/components/apps/pos/sale/main/include/DiningList.vue'
import tablelistView from '@/components/apps/pos/sale/main/include/TableList.vue'
import customerlistView from '@/components/apps/pos/sale/main/include/CustomerList.vue'
import paymentView from '@/components/apps/pos/sale/main/include/Payment.vue'
import paymentcomplateView from '@/components/apps/pos/sale/main/include/PaymentComplate.vue'
import LocalStorage from 'store'
import Barcoder from 'barcoder'
import { mapGetters, mapActions } from 'vuex'

import _ from 'lodash'

import firebaseMixin from '@/mixins/pos/firebase'

export default {
  name: 'PosMain',
  components: {
    chooseproductView,
    chooseattributeView,
    custompriceView,
    queuelistView,
    dininglistView,
    tablelistView,
    customerlistView,
    paymentView,
    paymentcomplateView,
  },
  mixins: [firebaseMixin],
  data () {
    return {
      ready: false,
      isMainReady: false,
      isChooseProductReady: false,

      pageHeight: 0,
      timer: null,
      timerInsertBills: null,
      isLoadingInsertBills: false,
      stockBills: [],
    }
  },
  computed: {
    ...mapGetters({
      pos: 'getPos',
      bills: 'getPosStockBills',
      network_status: 'getNetworkStatus', // online return true, offline return false,
      warehouses: 'getWarehouses',
      posSession: 'getPosSession',
      shopInfo: 'getShopInfo',
      getPosLocalStorage: 'getPosLocalStorage',
      posSettings: 'getPosSetting',
    }),
    mySessions () {
      return this.$store.state.possession.my.sessions
    },
    use_queue () {
      return this.posSettings.queue.is_active
    },
  },
  methods: {
    ...mapActions([
      'setPosLocalStorage',
      'setPosSection',
      'setPosDisplay',
      'insertPosBill',
      'deletePosStockBill',
      'doCalculateTotalPrice',
      'initPos',
    ]),
    getWindowHeight () {
      return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
    },
    handleWindowResize (event) {
      this.pageHeight = this.getWindowHeight()
    },
    async insertBillsInStock (bills) {
      if (!this.isLoadingInsertBills) {
        // set loading
        this.isLoadingInsertBills = true

        for (let item of bills) {
          const bill = {
            ...item,
            request_count: item.request_count ? item.request_count + 1 : 2,
            analytics: {
              ...item.analytics,
              is_sync_manual: false,
            },
          }

          let res = await this.insertPosBill(bill)
          if (res) {
            if (res.success) {
              this.deletePosStockBill(bill.uuid)
            } else {

            }
          }
        }

        // get pos products
        await this.$store.dispatch('getPosProducts', {
          ps_id: this.$route.query.id,
        })

        // set loading
        this.isLoadingInsertBills = false

        // loading finish
        this.showFinish(this.$Progress)
      }
    },
  },
  watch: {
    ready (newVal) {
      if (newVal) {
        this.initFirebase()
        this.showFinish(this.$Progress)
      }
    },
    'pos.display': {
      handler: function () {
        this.setPosLocalStorage({ psId: this.posSession.ps_id })
      },
      deep: true,
    },
    'pos.orders': {
      handler: function () {
        this.setPosLocalStorage({ psId: this.posSession.ps_id })
      },
      deep: true,
    },
    'pos.tables': {
      handler: function () {
        this.setPosLocalStorage({ psId: this.posSession.ps_id })
      },
      deep: true,
    },
    'pos.stockBills': {
      handler: function () {
        this.setPosLocalStorage({ psId: this.posSession.ps_id })
      },
      deep: true,
    },
    isChooseProductReady (newVal) {
      if (newVal && this.isMainReady) {
        this.ready = true
      }
    },
  },
  created: async function () { // call api to get data and set state
    /**
     *  validation
     */
    if (!this.$route.query.id) {
      return this.$router.push({ name: 'PosDashboard' })
    }

    // get pos session
    const responsePosSession = await this.$store.dispatch('getPosSession', {
      ps_id: this.$route.query.id,
    })

    if (this.use_queue) {
      await this.$store.dispatch('getPosBillLatestCode', {
        ps_id: this.$route.query.id,
      })
      await this.$store.dispatch('getPosBillUSedCodes', {
        ps_id: this.$route.query.id,
      })
    }

    if (responsePosSession.data.length == 0) {
      return this.$router.push({ name: 'PosDashboard' })
    } else if (responsePosSession.data[0].status == 'closed') {
      return this.$router.push({ name: 'PosDashboard' })
    }

    // comment this because it's warning for vue.
    // this.$router.push({name: 'PosDashboardSession', query: {id: this.posSession.ps_id}})
    /**
     *  validation success
     */

    // check stockBills, check pos orders
    var posLocalStorage = this.getPosLocalStorage(this.shopInfo.shop_id, this.posSession.ps_id) || {}

    this.initPos({
      shop_id: this.shopInfo.shop_id,
      ps_id: this.posSession.ps_id,
      stockbills: posLocalStorage.stockBills || [],
      orders: posLocalStorage.orders || [],
      tables: posLocalStorage.tables || [],
      display: posLocalStorage.display,
      queues: posLocalStorage.queues || [],
    })

    // set search bar to default
    this.setPosDisplay({ search: false })

    await Promise.all([
      this.$store.dispatch('getPosBranch', { id: this.posSession.branch_id, params: {} }),
      this.$store.dispatch('getDiscounts'),
      this.$store.dispatch('getTaxes'),
      this.$store.dispatch('getWarehouses'),
      this.$store.dispatch('getCustomers'),
      this.$store.dispatch('getRecipes'),
    ])

    // set ready
    this.isMainReady = true

    if (this.isChooseProductReady) {
      this.ready = true
    }
  },
  beforeMount: function () { // set states ui
    // init page
    this.initPage({
      section: 'pos',
      name: this.$t('app.pos.title'),
      current: {
        app_name: 'pos',
        app_id: 1,
      },
    })
  },
  mounted: function () { // run script
    let that = this
    // set pageHeight
    this.pageHeight = this.getWindowHeight()
    // event resize
    window.addEventListener('resize', this.handleWindowResize)
    // event keyboard
    window.addEventListener('keyup', this.handleKeyup, false)
    // loop
    this.timerInsertBills = setInterval(() => {
      let bills = _.cloneDeep(that.bills)
      let isOnline = that.network_status
      let haveBillsInStock = bills.length > 0
      if (isOnline) {
        if (haveBillsInStock) {
          // insert
          that.insertBillsInStock(bills)
        }
      }
    }, 1000)
  },
  updated: function () { // re-rendered html

  },
  destroyed: function () { // leave this page
    this.leavePage(this.$Progress, ['clearPosProducts', 'clearDiscounts', 'clearTaxes', 'clearWarehouses', 'clearCustomers'])
    // remove event keyboard
    window.removeEventListener('keyup', this.handleKeyup, false)
    // clear setInterval
    clearTimeout(this.timerInsertBills)
    // destroy barcoder scanner
    this.$barcodeScanner.destroy()
  },
}
</script>

<style scoped>
  #main-pos .content {
    position: relative;
    width: 100%;
    height: -webkit-calc(100% - 60px);
  	height:    -moz-calc(100% - 60px);
  	height:         calc(100% - 60px);
    top: 60px;
    background: var(--bg-grey-color);
  }
  #main-pos .tools-bar {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/pos/sale/main/Main.vue